/**
 * Phira's numeric derivative of a tween (F§7.3), used by the 170 speed integrator's Legacy sub-mode
 * (RPEVersion < 170) as d0 = f'(0) and d1 = f'(1):
 *
 *   eps = 1e-6, l = max(x - eps, 1e-7), r = min(x + eps, 1 - 1e-7), f'(x) = (f(r) - f(l)) / (r - l)      (f32)
 */

const fr = Math.fround;

const EPS = fr(1e-6);
const LOW = fr(1e-7);
const HIGH = fr(1 - LOW);

/** Rust `f32::max` / `f32::min` ignore a NaN operand. */
function rustMax(a: number, b: number): number {
  return Number.isNaN(a) ? b : Number.isNaN(b) ? a : Math.max(a, b);
}

function rustMin(a: number, b: number): number {
  return Number.isNaN(a) ? b : Number.isNaN(b) ? a : Math.min(a, b);
}

export function derivative(f: (x: number) => number, x: number): number {
  const xx = fr(x);
  const l = rustMax(fr(xx - EPS), LOW);
  const r = rustMin(fr(xx + EPS), HIGH);
  return fr(fr(fr(f(r)) - fr(f(l))) / fr(r - l));
}
